import React, { FC } from "react";
import OptionIcon from "../../../../../../images/sidebar/options-icon.svg";
import PricingIcon from "../../../../../../images/sidebar/item-pricing-logo.svg";
import ActiveOptionIcon from "../../../../../../images/sidebar/selected-option-icon.svg";
import ActivePricingIcon from "../../../../../../images/sidebar/selected-pricing-icon.svg";
import { observer } from "mobx-react";  
import DetailIcon from "../../../../../../images/common/link-blue.svg";
import ActiveDetailIcon from "../../../../../../images/sidebar/link-blue-gradient.svg";
import SellIcon from "../../../../../../images/common/cart-blue.svg";
import ActiveSellIcon from "../../../../../../images/common/cart-blue-green.svg";
import AfterPayIcon from "../../../../../../images/checkout/after-pay-blue.svg";
import ActiveAfterPayIcon from "../../../../../../images/checkout/after-pay-blue-red.svg";
import { NavigateFunction } from "react-router-dom";
import { CustomSideBar } from "../../../shared/components"; 
import { withRouter } from "@mindmemobile/mm-shared-global";
import { UpsertCheckoutActiveStep } from "../../../shared/enums";
import { CheckOutStore } from "../../../shared/store";

type IProps = {
  activeStep: UpsertCheckoutActiveStep;
  showVariant: boolean;
  onTabChange: (key: string) => void;
  checkoutStore: CheckOutStore;
  navigate: NavigateFunction;
};

const stepsData = [
  {
      step: UpsertCheckoutActiveStep.Detail,
      icon: DetailIcon,
      activeIcon: ActiveDetailIcon,
      title: 'Detail',
  },
  {
      step: UpsertCheckoutActiveStep.Sell,
      icon: SellIcon,
      activeIcon: ActiveSellIcon,
      title: 'Sell',
  },
  {
      step: UpsertCheckoutActiveStep.Pay,
      icon: PricingIcon,
      activeIcon: ActivePricingIcon,
      title: 'Payment',
  },
  {
      step: UpsertCheckoutActiveStep.AfterPay,
      icon: AfterPayIcon,
      activeIcon: ActiveAfterPayIcon,
      title: 'After Pay',
      className: 'after-pay-icon',
  },
  {
      step: UpsertCheckoutActiveStep.Options,
      icon: OptionIcon,
      activeIcon: ActiveOptionIcon,
      title: 'Options',
  },
];

const CheckOutSideBar: FC<IProps> = (props: IProps) => {
  return (
      <CustomSideBar
          activeStep={props.activeStep}
          showVariant={false}
          stepsData={stepsData}
          onTabChange={(key: string) => props.onTabChange(key)}
          checkoutStore={props.checkoutStore}
          className=""
      />
  );
};

export default withRouter(observer(CheckOutSideBar));
